import { APPRAISAL_STORAGE_KEYS } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/license-plate-and-vin-step/constants';

/**
 * Reads the persisted license plate value from storage.
 */
export function readStoredLicensePlate(storage) {
  const storedLp = storage.get(APPRAISAL_STORAGE_KEYS.LICENSE_PLATE);

  try {
    const parsed = JSON.parse(storedLp);
    return parsed ? String(parsed) : parsed;
  } catch {
    // Not JSON-encoded — use the raw stored string.
    return storedLp;
  }
}
